import { useEffect } from "react";
import consumer from "@/lib/cable";
import type {
  BizminerInsightRequest,
  BizminerPillarInsight,
} from "@/types/serializers";

interface InsightRequestUpdate {
  insight_request: BizminerInsightRequest;
  pillar_insight?: BizminerPillarInsight;
}

export function useDashboardChannels(
  pillarInsights: BizminerPillarInsight[],
  onUpdate: (
    insightRequest: BizminerInsightRequest,
    pillarInsight?: BizminerPillarInsight,
  ) => void,
) {
  useEffect(() => {
    if (!consumer) return;

    // Subscribe to all active insight requests
    const subscriptions = pillarInsights
      .filter((pillar) => pillar.insight_request?.id)
      .map((pillar) => {
        const insightRequestId = pillar.insight_request!.id;

        return consumer.subscriptions.create(
          {
            channel: "Bizminer::InsightRequestChannel",
            insight_request_id: insightRequestId,
          },
          {
            connected() {
              console.log(
                `Dashboard: Connected to InsightRequestChannel for request ${insightRequestId}`,
              );
            },

            disconnected() {
              console.log(
                `Dashboard: Disconnected from InsightRequestChannel for request ${insightRequestId}`,
              );
            },

            received(data: InsightRequestUpdate) {
              console.log("Dashboard: Received InsightRequest update:", data);
              onUpdate(data.insight_request, data.pillar_insight);
            },
          },
        );
      });

    // Cleanup all subscriptions on unmount
    return () => {
      subscriptions.forEach((subscription) => {
        subscription.unsubscribe();
      });
    };
  }, [pillarInsights.map((p) => p.insight_request?.id).join(","), onUpdate]);
}